<template>
  <div>
    <a-card  :bordered="false">
      <div class="table-page-search-wrapper">
        <span class="table-page-search-submitButtons">
          <a-row type="flex" justify="space-between" style="margin-bottom: 25px;">
            <a-col :span="24">
                 <a-button type="primary" style="margin-left: 8px;float: right"  @click="exportEnt2">导出 Excel</a-button>
            </a-col>
          </a-row>
        </span>
        <a-form layout="inline":form="form" >
          <!-- 筛选的条件-->
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="订单号" style="margin-left: 41px":labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input  v-model.trim="queryParam.orderNo" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 29px">
                <a-select  v-model="queryParam.installType" @change="installChange" :allowClear="true">
                  <a-select-option  v-for="type in installTypes" :title="type.dictLabel" :key="type.dictValue">{{type.dictLabel}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 29px">
                <a-select  v-model="queryParam.orderType" :allowClear="true" @change="getorderStatus">
                  <a-select-option  v-for="type in List" :title="type.typeName" :key="type.orderTypeId">{{type.typeName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 29px">
                <a-select  v-model="queryParam.orderStatus" :allowClear="true" @change="changeOrderStatus">
                  <a-select-option  v-for="type in order_status" :title="type.dictLabel" :key="type.dictValue">{{type.dictLabel}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item  label="客户姓名" style="margin-left: 29px;">
                <div style="display: flex;justify-content: space-between;align-items: center">
                  <a-input  v-model.trim="queryParam.customerName"/>
                  <!--<a-checkbox v-model="queryParam.isFuzzyClientName">模糊</a-checkbox>-->
                  <!--<a-switch size="small" v-model="queryParam.isFuzzyClientName" checked-children="模糊" un-checked-children="精确"/>-->
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item  label="客户联系方式" >
                <div style="display: flex;justify-content: space-between;align-items: center">
                  <a-input   v-model.trim="queryParam.customerPhone"/>
                  <!--<a-checkbox v-model="queryParam.isFuzzyClientPhone">模糊</a-checkbox>-->
                  <!--<a-switch size="small" v-model="queryParam.isFuzzyClientPhone" checked-children="模糊" un-checked-children="精确"/>-->
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" >
              <a-row :gutter="24" style="margin-left: 0px">
                <a-form-item  label="客户地址"style="margin-left: 29px">
                  <a-col :md="5" :sm="24">
                    <a-select  v-model="queryParam.customerProvinceCode"
                              @change="getselect" :allowClear="true">
                      <a-select-option  v-for="type in selectAllProvince"  :title="type.provinceName"  :key="type.provinceCode">{{type.provinceName}}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.customerCityCode"
                              @change="getprovinceName" :allowClear="true">
                      <a-select-option  v-for="type in selectCityName" :title="type.cityName"  :key="type.cityCode">{{type.cityName}}</a-select-option>
                    </a-select >
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.customerAreaCode" @change="countyonChange"  :allowClear="true">
                      <a-select-option  v-for="type in selectAreaName"  :title="type.areaName"  :key="type.areaCode">{{type.areaName}}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="9" :sm="24">
                    <a-input v-model.trim="queryParam.customerDetailAddress"/>
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
            <!--<a-col :md="6" :sm="24">-->
              <!--<a-form-item label="企业名称" style="margin-left: 29px" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
                <!--<a-input v-model.trim="queryParam.enterpriseName"></a-input>-->
              <!--</a-form-item>-->
            <!--</a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item  label="企业名称" style="margin-left: 29px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  v-model="queryParam.enterpriseId"
                  :disabled="EnterDisabled"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in selectCombox" :title="type.enterpriseName" :key="type.enterpriseId">{{type.enterpriseName}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="品牌" style="margin-left: 56px":labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select
                  showSearch

                  optionFilterProp="children"
                  @change="changeBrandName"
                  :filterOption="filterOption"
                  v-model="queryParam.brandId"
                  :allowClear="true"
                >
                  <a-select-option  v-for="type in selectBrand" :title="type.brandName" :key="type.brandId">{{type.brandName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="型号"style="margin-left: 56px":labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select
                  showSearch

                  optionFilterProp="children"
                  @change="changeModelName"
                  :filterOption="filterOption"
                  v-model="queryParam.modelId"
                  :allowClear="true"
                >
                  <a-select-option  v-for="type in selectModel" :title="type.modelName" :key="type.modelId">{{type.modelName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

               <a-col :md="6" :sm="24" v-if="!EnterDisabled">
                 <a-form-item label="订单负责人"  style="margin-left: 13px">
                   <a-select  v-model="queryParam.orderPrincipal" :allowClear="true">
                     <a-select-option  v-for="type in findByDeptId" :title="type.userName"  :key="type.userId">{{type.userName}}</a-select-option>
                   </a-select>
                 </a-form-item>
               </a-col>

          </a-row>
          <div v-if="Ifstatus">
            <a-row :gutter="24">


              <a-col :md="6" :sm="24">
                <a-form-item label="序列号" style="margin-left: 41px">
                  <div style="display: flex;justify-content: space-between;align-items: center">
                    <a-input  v-model.trim="queryParam.serialNumber"/>
                    <!--<a-checkbox v-model="queryParam.isFuzzySerialNumber">模糊</a-checkbox>-->
                    <!--<a-switch size="small" v-model="queryParam.isFuzzySerialNumber" checked-children="模糊" un-checked-children="精确"/>-->
                  </div>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item label="来源单号" style="margin-left: 29px">
                  <a-input v-model.trim="queryParam.sourceNo" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="服务号" style="margin-left: 41px">
                  <a-input v-model.trim="queryParam.serviceOrderNo" />
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item label="购买渠道" style="margin-left: 29px">
                  <a-select
                    showSearch
                    optionFilterProp="children"
                    @change="changesourceName"
                    :filterOption="filterOption"
                    v-model="queryParam.buyChannel"
                    :allowClear="true"
                  >
                    <a-select-option v-for="type in selectChannel" :title="type.channelName" :key="type.channelId">{{type.channelName}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="信息来源"style="margin-left: 29px">
                  <a-select
                    showSearch

                    optionFilterProp="children"
                    @change="changeinfoSourceName"
                    :filterOption="filterOption"
                    v-model="queryParam.infoSource"
                    :allowClear="true"
                  >
                    <a-select-option v-for="type in selectSource"  :title="type.sourceName" :key="type.sourceId">{{type.sourceName}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item label="建单人" style="margin-left: 41px">
                  <a-input  v-model.trim="queryParam.createBy"/>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24" v-if="!EnterDisabled">
                <a-form-item label="备注" style="margin-left: 56px">
                  <a-input  v-model.trim="queryParam.remark"/>
                </a-form-item>
              </a-col>


            </a-row>
          </div>
          <!--        查询和清空按钮-->
          <span class="table-page-search-submitButtons">
          <a-row type="flex" justify="space-between">
          <a-col :span="17" style="display: flex;justify-content: space-between;">

                 <a-checkbox style="margin-left: 106px;"  v-model="checkboxlist.isMainOrder" @change="onChangeMainOrder">重要订单</a-checkbox>

            </a-col>
            <a-col :span="7" :style="{ textAlign: 'right' }">
<!--              查询功能待完善 只能查询公司名-->
              <a-button type="primary"  style=""  htmlType="submit"   @click="getdataList1(1)">查询</a-button>
              <a-button style="margin-left: 8px;" @click="empty()">清空</a-button>

            </a-col>
          </a-row>
        </span>
          <a-row>
            <a-col :span="1" :offset="11">
              <span v-if="Ifstatus == 0" style="cursor:pointer" @click="getMore"><a-icon type="down-circle" theme="twoTone" style="fontSize:24px"/></span>
              <span v-if="Ifstatus == 1" style="cursor:pointer" @click="hiddenMore"><a-icon type="up-circle" theme="twoTone" style="fontSize:24px"/></span>
            </a-col>
            <a-col :span="12" :style="{ textAlign: 'right' }">
            </a-col>
          </a-row>

          <a-divider/>
          <div class="table-operator">
            <a-row>
              <a-col :span="12"></a-col>

              <a-col :span="12" :style="{ textAlign: 'right' }">

                <a-button class="ncreate"  type="primary" icon="plus" style="margin-bottom: 20px;"
                          @click="goNewlyaddedOrderList" >新增订单
                </a-button>
                <a-button class="ncreate" type="primary" style="margin-left: 8px" @click="ordersSort">排序 </a-button>

              </a-col>
            </a-row>
          </div>
        </a-form>
      </div>
      <!--    表格内容-->
      <a-table
        size="small"
        ref="table"
        rowKey="orderId"
        :columns="columns"
        :dataSource="loadData"
        :pagination="false"
        bordered
        :loading="loading"
        :scroll="{ x: 3600 }"
        :row-selection="rowSelection"
        :rowClassName='setClassName'
      >
        <!--<span v-if="!clientNoShow" slot="clientPhone" slot-scope="text, record">-->
        <!--{{phoneFormat(text)}}-->
        <!--</span>-->
        <span slot="clientPhone" slot-scope="text, record">
          {{text}}
        </span>
        <!--<span v-if="!masteInfoPhoneNoAll" slot="masterPhone" slot-scope="text, record">-->
        <!--{{phoneFormat(text)}}-->
        <!--</span>-->

        <span slot="masterSettleStatus" slot-scope="text, record">
        <td v-for="type in masterSettleStatus2" :key="type.dictValue" v-if="record.masterSettleStatus == type.dictValue" >{{type.dictLabel}}</td>
        </span>

        <span slot="masterPhone" slot-scope="text, record">
          {{text}}
        </span>
        <span slot="action" slot-scope="text, record">
          <a   @click="editorder(record)">编辑</a>
          </span>
          <!--<a-divider type="vertical" v-if="Ifstatusicon == 1"/>-->
          <a v-if="Ifstatusicon == 1" @click="hiddenMoreLeft"> <a-icon type="left" /></a>
        </span>
        <span slot="clientAddress" slot-scope="text, record">
        <!--style="white-space: normal;width: 200px"-->
          <a @click="changeclientAddress(record)">{{text}}</a>
       </span>
        <span slot="orderNo" slot-scope="text, record">
          <a @click="addremark(record)">{{text}}</a>
        <a title="复制"><a-icon type="copy" class="copy"  @click="Copys(record)"/></a>
            </span>
        <span slot="sourceNo" slot-scope="text, record">
          {{ text }}
        </span>
        <span slot="serviceOrderNo" slot-scope="text, record">
          {{ text }}
        </span>
        <span slot="enterpriseName" slot-scope="text, record">
              <a-popover >
                <template slot="content" >
                  <div style="overflow-y:auto;max-height:450px;padding-right: 20px">
                    <p>企业全称:{{record.enterpriseFullName}}</p>
                    <p>企业负责人:{{record.enterprisePrincipal}}</p>
                    <p>企业负责人电话:{{record.principalPhone}}</p>
                    <p>技术人员:{{record.technology}}</p>
                    <p>技术人员电话:{{record.technologyPhone}}</p>
                    <p>技术人员2:{{record.technology2}}</p>
                    <p>技术人员2电话:{{record.technology2Phone}}</p>
                    <p>客户负责人:{{record.customerService}}</p>
                    <p>客户负责人电话:{{record.customerServicePhone}}</p>
                  </div>
                </template>
                <a type="primary">
                  {{record.enterpriseName}}
                </a>
              </a-popover>
            </span>
        <span slot="marketPrincipal" slot-scope="text, record">
              <a-popover >
                <template slot="content" >
                  <div style="overflow-y:auto;max-height:450px;padding-right: 20px">

                    <p>市场负责人电话:{{record.marketPrincipalPhone}}</p>

                  </div>
                </template>
                <a type="primary">
                  {{text}}
                </a>
              </a-popover>
            </span>
        <span slot="masterName" slot-scope="text, record">
          <span class="hover">{{text}} </span>
          <a title="复制" v-if="text"><a-icon type="copy" class="copy"  @click="Copys2(record)"/></a>
        </span>
        <span slot="clientName" slot-scope="text, record">
          <span class="hover">{{text}} </span>
          <a title="复制"><a-icon type="copy" class="copy"  @click="Copys3(record)"/></a>
        </span>
        <span slot="orderSubStatus" slot-scope="text, record">
          <a-popover>
            <template slot="content">
              <p>全部子状态:{{record.orderSubStatusAll}}</p>
            </template>
         <a class="hover">{{text}} </a>
        </a-popover>

      </span>
        <span slot="lastHelperName" slot-scope="text, record">
          <a-popover>
            <template slot="content">
              <p>全部订单协助人:{{record.helperName}}</p>
            </template>
         <a class="hover">{{text}} </a>
        </a-popover>
      </span>
      </a-table>
      <a-pagination showQuickJumper="true" showSizeChanger
                    :pageSizeOptions="pageSizeOptions"
                    :pageSize.sync="pageSize"
                    @showSizeChange="onShowSizeChange"
                    :total="total"
                    v-model="current"
                    @change="getdataList1"
                    :showTotal="total => `总共 ${total} 条`"
                    style="text-align: right;margin-top: 20px"
      />
      <!-- 使用弹框组件-->
      <Enterprise-modal ref="modal" @ok="handleOk"/>
      <!--    移除对账单确定按钮-->
      <a-modal
        title="移除"
        style="top: 20px;"
        :width="800"
        v-model="removeible"
        :confirmLoading="confirmLoading"
        @ok="confirmOk"
        @cancel="confirmCancel"
      >
        <a-form  ref="ruleForm"  :form="form"  >
          <a-form-item label="移除类型"  :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select v-decorator="['removeType',{ rules: [{
                        required: true, message: '请选择移除类型!' }] },]" @change="removeTypechange">
              <a-select-option v-for="type in remove_type" :key="type.dictValue" >{{type.dictLabel}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="备注"  :labelCol="labelCol" :wrapperCol="wrapperCol"
          >
            <a-input type="textarea" v-decorator="['removeText',{ rules: [{
                        required: this.removerequiredbool, message: '请填写备注!' }] },]" />
          </a-form-item>
        </a-form>
      </a-modal>
      <a-modal
        title="改派"
        style="top: 20px;"
        :width="800"
        v-model="reformistible"
        @ok="reformistOk"
        @cancel="reformistCancel"
      >
        <a-form :form="formreformist">
          <a-row>
            <a-col >
              <a-form-item style="display:none">
                <a-input v-decorator="['orderId']"/>
              </a-form-item>
              <a-form-item label="当前主负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['oldorderPrincipal']"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新主负责人">
                <a-select v-decorator="['orderPrincipal',{ rules: [{ required: true, message:'请选择新主负责人!' }] }]">
                  <a-select-option  v-for="type in findByDeptId" :key="type.userId">{{type.userName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>
      </a-modal>
      <a-modal  v-model="changeclientAddressible" @ok="determinechangeclientAddress()"
                title="修改客户地址" >
        <a-form :form="formchangeclientAddress">
          <a-row>
            <a-col >
              <a-form-item style="display:none">
                <a-input v-decorator="['orderId']"/>
              </a-form-item>
              <a-form-item label="省" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select @change="getselect" v-decorator="['provinceId', { rules: [{ required: true,
     message:'请选择客户地址!' }] }]" :allowClear="true">
                  <a-select-option v-for="type in selectAllProvince" :key="type.provinceCode">
                    {{type.provinceName}}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="市">
                <a-select v-decorator="['cityId', { rules: [{ required: true, message:'请选择客户地址!' }] }]"
                          @change="getprovinceName" :allowClear="true">
                  <a-select-option v-for="type in selectCityName" :key="type.cityCode">
                    {{type.cityName}}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="区">
                <a-select @change="getAreaStatu" v-decorator="['countyId', { rules: [{ required: true, message:'请选择客户地址!' }] }]" :allowClear="true">
                  <a-select-option v-for="type in selectAreaName" :key="type.areaCode">
                    {{type.areaName}}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="详细地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['address',{ rules: [{ required: true, message: '请填写详细地址!' }] },]"/>
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>
      </a-modal>
      <a-modal
        title="导入失败文件"
        style="top: 20px;"
        v-model="bisible"
        @ok="handleSubmit2"
        :closable="false"
        :maskClosable="false"
      >
        <div style="margin-left: 50px">
          <p>
            <strong>导入成功数量 : </strong>
            <span>{{success}}</span>
          </p>
          <p>
            <strong>导入失败数量 : </strong>
            <sapn style="color: red">{{err}}</sapn>
          </p>
          <strong v-if="err == 0">全部导入成功！</strong>
          <strong v-else>是否下载导入失败文件？</strong>
        </div>
      </a-modal>
      <a-modal v-model="orderCloseible" @ok="addorderClose() " title="关闭理由" :width="600">
        <a-form :form="orderCloseform">
          <a-row>
            <a-col>
              <a-form-item  :labelCol="labelCol" :wrapperCol="wrapperCol" label="关闭类型">
                <a-select v-decorator="['refusalOrderReason', { rules: [{
                required: true, message: '请选择关闭类型!' }] }]"  :allowClear="true" @change="orderClosechange">
                  <a-select-option v-for="type in close_order_type" :key="type.dictValue">{{type.dictLabel}}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item  :labelCol="labelCol" :wrapperCol="wrapperCol" label="关闭理由">
                <a-input v-decorator="['reasonContext', { rules: [{required: this.orderCloseBool,
              message:
              '请填写理由!' }] }]" type="textarea"/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <select-order-frozen-model ref="selectorderfrozen" @selectorderok="query()"></select-order-frozen-model>
      <leaflets-distribute-model ref="leaflets" @ok="query()"></leaflets-distribute-model>
      <edit-order-model ref="editordermodel22" @ok="query()"></edit-order-model>
      <newlyadded-order-list-model @ok="query()" ref="newlyaddedorderlist"></newlyadded-order-list-model>
      <change-remarks-model  @ok="query()"
                             ref="changeremarksmodel"></change-remarks-model>
      <orders-sort-model ref="orderssort" @ok="undataUserOrderSort"></orders-sort-model>
    </a-card>
    <!--<no-authority  ></no-authority>-->
  </div>
</template>
<script>
import selectOrderFrozenModel from './modules/selectOrderFrozenModel'
import ordersSortModel from './modules/ordersSortModel'
import leafletsDistributeModel from './modules/leafletsDistributeModel'
import NewlyaddedOrderListModel from './modules/NewlyaddedOrderListModel'
import changeRemarksModel from './modules/changeRemarksModel'
import NoAuthority from '../enterprise/NoAuthority'
import { checkPermission } from '@/utils/permissions'
import { STable } from '@/components'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import store from '@/store'
import {
  orderLink,
  getSourceList,
  getSelectBrand,
  getSelectModel,
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getdeleteOrder,
  getList,
  getOrderDetail,
  getorderInfo,
  getfindByDeptId,
  getmarketPrincipal,
  getisOrderOpened,
  getagainDispatchOrder,
  getmasterPrincipal,
  getchangeOrderPrincipal,
  batchCustomerServiceApply,
  getexportList,
  batchOrderExport,
  getfinddictAll,
  generateShortUrl
} from '@/api/order/orderList'
import moment from 'moment'
import { getselectChannel, getselectSource, getselectCombox } from '@/api/order/NewlyaddedOrderList'
import {
  getupdateOrder,
  getUserOrderSort,
  getcompleteOrder,
  getreviewOrder,
  getreceiveOrder,
  getreservationOrder,
  getinstallOrder,
} from '@/api/order/editorder'
import pick from 'lodash.pick'
import ARow from 'ant-design-vue/es/grid/Row'
const options = [
  { label: '未完成订单', value: '为完成订单' },
  { label: '暂不结算', value: '暂不结算' },

  { label: '该账号订单', value: '该账号订单' },
  { label: '加急订单', value: '加急订单' },
  { label: '重要订单', value: '重要订单' },
  { label: '冻结订单', value: '冻结订单' },
]
const optionsradio = [
  { label: '小时', value: '0' },
  { label: '天', value: '1' },
]

export default {
  name: 'EnterpriseBill',
  components: {
    ARow,
    STable,
    // 注册弹框组件
    leafletsDistributeModel,
    NewlyaddedOrderListModel,
    selectOrderFrozenModel,
    editOrderModel: () => import('./modules/editOrderModel1'),
    changeRemarksModel,
    ordersSortModel,
    NoAuthority,
  },
  data() {
    return {
      store,
      // 分页
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      total: 0,
      current: 1,
      pageSize: 10,
      //
      reserve_type: [], // 预约类型
      reserve_failed_reason: [], // 预约失败类型
      showReserveFailType: false,
      jumpList: '',
      isTrue: true,
      arrList: '',
      success: '',
      err: '',
      bisible: false,
      orderCloseible: false,
      close_order_type: [],
      methodType: 'get',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      uploadUrl: process.env.VUE_APP_API_BASE_URL + '/order/order/batchOrderImport',
      uploadUrlMandatory: process.env.VUE_APP_API_BASE_URL + '/order/order/batchOrderImportMandatory',
      EnterDisabled: false, //是否是企业账户
      Ifstatus: 0,
      Ifstatusicon: 0,
      checkboxlist: {
        temporarily: false,
        freezeOrder: false,
        undoneOrder: false,
        urgentOrder: false,
        myOrder: false,
      },
      selectedRowKeys: [],
      order_substate: [],
      selectedRows: [],
      dtoListtab: {},
      dtoListtab2: {},
      dtoListtab3: {},
      // 查询信息来源下拉框
      selectSource: [],
      // 查询购买渠道下拉框
      selectChannel: [],
      selectCombox: [],
      List: [],
      valueRadio: '0',
      value: '0',
      valuecheckbox: [],
      options,
      optionsradio,
      orderId: '',
      removeText: '',
      removeType: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      // 字典为订单状态
      order_status: [],
      // 字典为订单超时状态
      timeout_type: [],
      // 字典为付款状态
      pay_status: [],
      // 字典为快递公司
      delivery_company: [],
      // 字典为快递公司
      tech_level: [],
      // 字典为快递公司
      worker_type: [],
      // 时间类型
      selectBrand: [],
      // 查询品牌下拉框
      time_type: [],
      // 付款方式
      pay_type: [],
      // 结算角色
      settle_role: [],
      // 结算状态
      settlement_status: [],
      masterSettleStatus2: [],
      // 结算状态
      settle_cycle: [],
      // 省
      selectAllProvince: [],
      // 市
      selectCityName: [],
      // 区
      selectAreaName: [],
      // 查询型号下拉框
      selectModel: [],
      // 查询型号下拉框
      remove_type: [],
      removeible: false,
      removeLoading: false,
      reformistible: false,
      loading: true,
      changeclientAddressible: false,
      removerequiredbool: false,
      orderCloseBool: false,
      form: this.$form.createForm(this),
      OrderOpenedForm: this.$form.createForm(this),
      formreformist: this.$form.createForm(this),
      orderCloseform: this.$form.createForm(this),
      formchangeclientAddress: this.$form.createForm(this),
      // 查询参数
      queryParam: {
        timeType1: '',
        orderStatus: '',
      },
      dtoList: [],
      timeType1: '',
      timeType2: '',
      timeType3: '',
      // post的返回值
      reslist: '',
      orderTypeId: '',
      findByDeptId: [],
      isOrderOpenedmsg: [],
      marketPrincipal: [],
      // 加载数据方法 必须为 Promise 对象
      loadData: [],
      data: [],
      enterpriseIdbool: () => {
        if (this.$store.getters.enterpriseId) {
          return true
        } else {
          return false
        }
      },
      sys_yes_no: [],
      // 字典为安装类型
      installTypes: [],
      orderjumpStatus: '',

      detailTime: checkPermission('order:list:detail:detailTab:masterInfo:detailTime'),

      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'no',
          align: 'center',
        },
        {
          title: '操作栏',
          // width: '270px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          align: 'center',
        },
        {
          title: '来源单号',
          dataIndex: 'sourceNo',
          scopedSlots: { customRender: 'sourceNo' },
          align: 'center',
        },
        {
          title: '服务号',
          dataIndex: 'serviceOrderNo',
          scopedSlots: { customRender: 'serviceOrderNo' },
          align: 'center',
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatusName',
          align: 'center',
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          scopedSlots: { customRender: 'enterpriseName' },
          align: 'center',
        },

        {
          title: '客户姓名',
          dataIndex: 'clientName',
          scopedSlots: { customRender: 'clientName' },
          align: 'center',
        },
        {
          title: '联系方式',
          dataIndex: 'clientPhone',
          className: checkPermission('order:list:detail:detailTab:clientNo:show') ? '' : 'notshow',
          scopedSlots: { customRender: 'clientPhone' },
          align: 'center',
        },
        {
          title: '客户地址',
          dataIndex: 'clientAddress',
          // header-align:"center",
          scopedSlots: { customRender: 'clientAddress' },
        },
        {
          title: '预约上门时间',
          dataIndex: 'reserveTime',
          align: 'center',
        },
        {
          title: '销单时间',
          dataIndex: 'saleTime',
          className: checkPermission('order:list:detail:detailTab:masterInfo:detailTime') ? '' : 'notshow',
          align: 'center',
        },
        {
          title: '核销时间',
          dataIndex: 'checkTime',
          align: 'center',
        },
        {
          title: '订单完成时间',
          dataIndex: 'orderFinishTime',
          align: 'center',
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '建单人',
          dataIndex: 'createBy',
          align: 'center',
        },
        {
          title: '超时时长',
          dataIndex: 'timeOutDuration',
          align: 'center',
        },
        {
          title: '介入时间',
          dataIndex: 'intervenDuration',
          align: 'center',
        },
      ],
      editordererecord: '',
      masterPrincipal: [],
      StoreUserId: '',
      userType: '',
      userId: '',
    }
  },
  filters: {},
  mounted() {
    // this.query()
    this.orderTypeId = this.$route.params.id
    this.orderjumpStatus = this.$route.params.status
    if (this.$route.params.jumpList) {
      this.jumpList = this.$route.params.jumpList
      this.queryParam.orderStatus = this.jumpList.orderStatus
      this.queryParam.isFreezeOrder = this.jumpList.isFreezeOrder
      this.queryParam.isTemporarilySettle = this.jumpList.isTemporarilySettle
      this.queryParam.timeOutType = this.jumpList.timeOutType
      this.queryParam.isUrgentOrder = this.jumpList.isUrgentOrder
      this.queryParam.isMyOrder = this.jumpList.isMyOrder

      this.checkboxlist.freezeOrder = this.jumpList.isFreezeOrder == 1 ? true : false
      this.checkboxlist.temporarily = this.jumpList.isTemporarilySettle == 1 ? true : false
      this.checkboxlist.urgentOrder = this.jumpList.isUrgentOrder == 1 ? true : false
      this.checkboxlist.myOrder = this.jumpList.isMyOrder == 1 ? true : false
      this.queryParam.timeType1 = this.jumpList.timeType1
      if (this.jumpList.timeStart1 != null && this.jumpList.timeEnd1 != null) {
        this.timeType1 = [moment(this.jumpList.timeStart1), moment(this.jumpList.timeEnd1)]
        this.queryParam.timeStart1 = this.jumpList.timeStart1
        this.queryParam.timeEnd1 = this.jumpList.timeEnd1
      } else {
        this.timeType1 = null
        this.queryParam.timeStart1 = null
        this.queryParam.timeEnd1 = null
      }
    }
    // this.handloadData()
  },

  // 下拉框的选项
  created() {
    this.StoreUserId = this.$store.getters.enterpriseId
    this.userType = this.$store.getters.userType
    this.userId = this.$store.getters.userId
    if (this.StoreUserId) {
      this.EnterDisabled = true
    }
    // 订单负责人
    this.masterPrincipal = []
    getmasterPrincipal().then((res) => {
      this.masterPrincipal = res
    })
    this.findByDeptId = []
    getfindByDeptId().then((res) => {
      this.findByDeptId = res
    })
    this.marketPrincipal = []
    getmarketPrincipal().then((res) => {
      //console.log('市场负责人',res)
      this.marketPrincipal = res
    })
    // 企业名称
    this.selectCombox = []
    getselectCombox().then((res) => {
      if (res.code === 0) {
        this.selectCombox = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.selectSource = []
    // 查询信息来源下拉框
    getselectSource().then((res) => {
      if (res.code === 0) {
        this.selectSource = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.selectChannel = []
    getselectChannel().then((res) => {
      if (res.code === 0) {
        this.selectChannel = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.time_type = []
    let dictTypes = [
      'reserve_failed_reason',
      'reserve_type',
      'order_substate',
      'install_type',
      'close_order_type',
      'order_status',
      'timeout_type',
      'delivery_company',
      'pay_status',
      'worker_type',
      'tech_level',
      'time_type',
      'pay_type',
      'settle_role',
      'remove_type',
      'settlement_status',
    ]
    getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
      this.reserve_type = res.reserve_type
      this.reserve_failed_reason = res.reserve_failed_reason
      this.order_substate = res.order_substate
      this.installTypes = res.install_type
      this.order_status = res.order_status
      this.timeout_type = res.timeout_type
      this.delivery_company = res.delivery_company
      this.pay_status = res.pay_status
      this.worker_type = res.worker_type
      this.tech_level = res.tech_level
      this.pay_type = res.pay_type
      this.settle_role = res.settle_role
      this.remove_type = res.remove_type
      this.close_order_type = res.close_order_type
      this.masterSettleStatus2 = res.settlement_status
      //console.log(this.settle_role)
      this.settle_role = res.settle_role
      this.time_type = res.time_type
    })

    this.selectBrand = []
    getSelectBrand().then((res) => {
      if (res.code === 0) {
        this.selectBrand = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    this.selectModel = []
    getSelectModel().then((res) => {
      if (res.code === 0) {
        this.selectModel = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    getselectAllProvince().then((res) => {
      if (res.code === 0) {
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
    this.getdataList1(1)
    this.userOrderSort()
  },
  // 计算选中的数据条数
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        selectedRowKeys: this.selectedRowKeys,
      }
    },
  },
  methods: {
    getReserveType(e) {
      if (e == 1) {
        this.showReserveFailType = true
      } else {
        this.showReserveFailType = false
      }
    },
    changeTimeOutType(e) {
      this.$set(this.queryParam, this.queryParam.timeOutType, e)
    },
    changeTimeType1(e) {
      // console.log(e)
      this.$set(this.queryParam, this.queryParam.timeType1, e)
    },
    changeOrderStatus(e) {
      // console.log(e)
      this.$set(this.queryParam, this.queryParam.orderStatus, e)
    },
    // 分页
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.getdataList1(current)
    },
    getdataList1(value) {
      this.loading = true
      // console.log(this.orderTypeId)
      // console.log(this.$route.params)
      //  if(this.$route.params.id != undefined && this.isTrue){
      //    this.orderTypeId = this.$route.params.id
      //    this.orderjumpStatus = this.$route.params.status
      //  }else{
      //    this.orderTypeId = undefined
      //    this.orderjumpStatus = undefined
      //  }
      this.current = value
      this.queryParam.pageNum = value
      this.queryParam.pageSize = this.pageSize
      this.handloadData()
    },
    handloadData() {
      let val = this.queryParam
      if (this.orderTypeId != undefined) {
        // 1. 首页跳转过来的
        // this.queryParam.orderType = this.orderTypeId
        //企业账号
        if (this.userType == '22') {
          this.queryParam.enterpriseId = this.StoreUserId
          // if(this.orderjumpStatus == 1){
          //   this.queryParam.entUserId = this.userId
          // }else{
          //   delete this.queryParam.entUserId
          // }
        }
        // 锁安账号
        if (this.userType == '00') {
          //个人订单
          if (this.orderjumpStatus == 1) {
            this.queryParam.userId = this.userId
          } else {
            delete this.queryParam.userId
          }
        }
      } else {
        // console.log('shuoye22222222')
        // 1. 非首页跳转
        if (this.StoreUserId.length != 0) {
          this.queryParam.enterpriseId = this.StoreUserId
          this.EnterDisabled = true
        }
      }
      // 不是企业用户和不能看所有订单

      getSourceList(this.queryParam).then((res) => {
        // console.log('res',res)
        let that = this
        for (let j = 0; j <= that.installTypes.length - 1; j++) {
          for (let i = 0; i <= res.rows.length - 1; i++) {
            if (res.rows[i].installType == this.installTypes[j].dictValue) {
              res.rows[i].installType = this.installTypes[j].dictLabel
            }
          }
        }
        for (let j = 0; j <= this.order_status.length - 1; j++) {
          for (let i = 0; i <= res.rows.length - 1; i++) {
            if (res.rows[i].orderStatus == this.order_status[j].dictValue) {
              res.rows[i].orderStatus = this.order_status[j].dictLabel
            }
          }
        }
        for (let j = 0; j <= that.pay_type.length - 1; j++) {
          for (let i = 0; i <= res.rows.length - 1; i++) {
            if (res.rows[i].payType == this.pay_type[j].dictValue) {
              res.rows[i].payType = this.pay_type[j].dictLabel
            }
          }
          this.loadData = res.rows
          this.total = res.total
          this.loading = false
        }
      })
    },
    // phoneFormat(phoneNum) {
    //   if (Number(phoneNum) && String(phoneNum).length === 11) {
    //     const mb = String(phoneNum);
    //     const reg = /^(\d{3})\d{4}(\d{4})$/;
    //     return mb.replace(reg, '$1****$2');
    //   } else {
    //     return phoneNum;
    //   }
    // },
    settleRoleChange(e) {
      this.form.setFieldsValue({
        settleStatus: undefined,
        settleCycle: undefined,
      })
      // this.queryParam.settleStatus=''
      if (e) {
        let dictTypes = ['settle_cycle', 'settlement_status']
        getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
          this.settlement_status = res.settlement_status
          this.settle_cycle = res.settle_cycle
          // console.log(res.time_type)
        })
      } else {
        this.settlement_status = []
        this.settle_cycle = []
      }
    },

    modifiedamount(record) {
      this.$nextTick(() => {
        this.$refs.editordermodel22.showeditOrder(record.orderId, 2, 1)
      })
      let that = this
      setTimeout(function () {
        that.$refs.editordermodel22.changePrice()
      }, 1000)
    },
    selectOrderFrozen(record) {
      this.$refs.selectorderfrozen.showselectOrderFrozen(record.orderId)
    },

    orderClosechange(value) {
      if (value != 0) {
        this.orderCloseBool = true
      } else {
        this.orderCloseBool = false
      }
    },
    addorderClose() {
      this.orderCloseform.validateFields((err, values) => {
        values.reasonType = 2
        values.orderId = this.closerecord.orderId
        values.procInstId = this.closerecord.procInstId
        values.applyResult = this.applyResult
        if (this.closerecord.orderStatusCode == 'reviewOrder') {
          getreviewOrder(values).then((res) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.query()
              this.orderCloseible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
        if (this.closerecord.orderStatusCode == 'receiveOrder') {
          getreceiveOrder(values).then((res) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.query()
              this.orderCloseible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
        if (this.closerecord.orderStatusCode == 'reservationOrder') {
          getreservationOrder(values).then((res) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.query()
              this.orderCloseible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
        if (this.closerecord.orderStatusCode == 'installOrder') {
          getinstallOrder(values).then((res) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.query()
              this.orderCloseible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
        if (this.closerecord.orderStatusCode == 'completeOrder') {
          getcompleteOrder(values).then((res) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.query()
              this.orderCloseible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    close(record) {
      this.orderCloseBool = false
      this.orderCloseform.resetFields()
      this.orderCloseible = true
      this.applyResult = 2
      this.closerecord = record
    },
    undataUserOrderSort() {
      this.userOrderSort()
    },
    userOrderSort() {
      getUserOrderSort().then((res) => {
        // console.log(res.data)
        if (res.code === 0) {
          if (res.data.length > 0) {
            //
            for (let col of res.data) {
              col.align = 'center'
              if (col.title == '序号') {
                col['dataIndex'] = 'id'
              }
              if (col.dataIndex == 'action') {
                col['scopedSlots'] = { customRender: 'action' }
                col.align = 'left'
              }
              if (col.dataIndex == 'orderNo') {
                col['scopedSlots'] = { customRender: 'orderNo' }
              }
              if (col.dataIndex == 'sourceNo') {
                col['scopedSlots'] = { customRender: 'sourceNo' }
              }
              if (col.dataIndex == 'serviceOrderNo') {
                col['scopedSlots'] = { customRender: 'serviceOrderNo' }
              }
              if (col.dataIndex == 'orderSubStatus') {
                col['scopedSlots'] = { customRender: 'orderSubStatus' }
              }
              if (col.dataIndex == 'enterpriseName') {
                col['scopedSlots'] = { customRender: 'enterpriseName' }
              }
              if (col.dataIndex == 'marketPrincipal') {
                col['scopedSlots'] = { customRender: 'marketPrincipal' }
              }
              if (col.dataIndex == 'clientName') {
                col['scopedSlots'] = { customRender: 'clientName' }
              }
              if (col.dataIndex == 'clientAddress') {
                col['scopedSlots'] = { customRender: 'clientAddress' }
                col.align = 'left'
              }
              if (col.dataIndex == 'lastHelperName') {
                col['scopedSlots'] = { customRender: 'lastHelperName' }
              }

              if (col.dataIndex == 'masterSettleStatus') {
                col['scopedSlots'] = { customRender: 'masterSettleStatus' }
              }
            }
            this.columns = res.data
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    ordersSort() {
      this.$refs.orderssort.showorderSort()
    },

    handcopy(data) {
      let url = data
      let oInput = document.createElement('textArea')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message.success('复制成功')
      oInput.remove()
    },
    async Copys(val) {
      console.log(val)
      let remarkStr = ''
      let shortUrlStr = ''
      let guidePlateStr = ''
      try {
        if (val.masterId) {
          try {
            const resUrl = await generateShortUrl({ userId: val.masterId, orderId: val.orderId })
            console.log(resUrl)
            if (resUrl.code === 0 && resUrl.data) {
              shortUrlStr = `\n短链：${resUrl.data}\n`
            }
          } catch (e) {
            console.error('获取短链失败', e)
          }
        }
        if (val.isCounterVane == 0) {
          guidePlateStr = `导向片长度(mm):${val.counterVaneLength || 0}\n导向片宽度(mm):${val.counterVaneWidth || 0}\n`
        }
        const res = await getOrderDetail({ orderId: val.orderId })
        if (res.code == 0 && res.data) {
          if (res.data.orderRemark) {
            const remarks = res.data.orderRemark
            if (remarks.length > 0) {
              remarkStr = '\n工单备注信息：'
              remarks.forEach((item, index) => {
                remarkStr += `\n 备注${index + 1}：${item.remarkInfo || ''} (操作人：${item.updateBy || ''} 时间：${item.updateTime || ''})`
              })
            }
          }
        }
      } catch (error) {
        console.error('获取工单详情失败', error)
      }
      this.copyData =
        `订单号:` +
        val.orderNo +
        '\n' +
        (val.sourceNo ? `来源单号:` + val.sourceNo + '\n' : '') +
        (val.serviceOrderNo ? `服务号:` + val.serviceOrderNo + '\n' : '') +
        guidePlateStr +
        `客户姓名:` +
        val.clientName +
        '\n' +
        `客户联系方式:` +
        val.clientPhone +
        '\n' +
        `客户地址:` +
        val.clientAddress +
        remarkStr
      this.handcopy(this.copyData)
    },
    Copys2(val) {
      console.log(val)
      this.copyData = `师傅姓名:` + val.masterName + '\n' + `师傅联系方式:` + val.masterPhone
      this.handcopy(this.copyData)
    },
    Copys3(val) {
      console.log(val)
      this.copyData =
        `客户姓名:` +
        val.clientName +
        '\n' +
        `;客户联系方式:` +
        val.clientPhone +
        '\n' +
        `客户地址:` +
        val.clientAddress
      this.handcopy(this.copyData)
    },
    moment,
    setClassName(record) {
      if (record.isTimeoutOrder == 1) {
        //超时订单
        return 'clickRowStyle'
      } else if (record.isUrgentOrder == 1) {
        //加急订单
        return 'clickRowStyle3'
      }
      if (record.auditStatus == 0) {
        return 'clickRowStyle4'
      }
    },
    // 失败文件处理
    handleSubmit2() {
      if (this.err == 0) {
        this.bisible = false
      } else {
        batchOrderExport(this.arrList).then((res) => {
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
          const a = document.createElement('a')
          // 生成文件路径
          let href = window.URL.createObjectURL(blob)
          a.href = href
          let fileName = '导入失败订单文件'
          // 文件名中有中文 则对文件名进行转码
          a.download = decodeURIComponent(fileName)
          // 利用a标签做下载
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(href)
        })
        this.bisible = false
        this.query()
      }
    },
    // 导入
    handleChange(info) {
      // console.log(11111111111, info, info.file.response)
      if (info.file.status === 'done') {
        if (info.file.response.code == 500) {
          this.$message.error(info.file.response.msg)
        } else {
          const file = info.file.response.data
          if (file.failNum > 0) {
            this.bisible = true
            this.success = file.successNum
            this.err = file.failNum
            this.arrList = file.failDtoList
          } else if (file.failNum == 0 && file.successNum == 0) {
            this.$message.error(`无数据导入`)
          } else {
            this.$message.success('导入成功')
          }
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 导入失败`)
      }
    },
    handleChangeMandatory(info) {
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        let file = info.file.response.data
        if (file.failNum > 0) {
          this.bisible = true
          this.success = file.successNum
          this.err = file.failNum
          this.arrList = file.failDtoList
        } else if (file.failNum == 0 && file.successNum == 0) {
          this.$message.error(`无数据导入.`)
        } else {
          this.query()
          this.$message.success('导入成功')
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 导入失败.`)
      }
    },

    getsettleStatus(val) {
      this.queryParam.settleStatus = val
      // console.log(val)
      // if (val) {
      //   this.$set(this.queryParam, this.queryParam.settleStatus, val.value)
      // } else {
      //   this.$set(this.queryParam, this.queryParam.settleStatus, '')
      // }
    },
    getsettleCycle(val) {
      this.queryParam.settleCycle = val
      // if (val) {
      //   this.$set(this.queryParam, this.queryParam.settleCycle, val.value)
      // } else {
      //   this.$set(this.queryParam, this.queryParam.settleCycle, undefined)
      // }
    },
    getorderStatus(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.orderType, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.orderType, undefined)
      }
    },

    exportEnt2() {
      // console.log('this.queryParam',this.queryParam)
      this.$axios({
        method: 'get',
        url: 'api/order/lock/export',
        params: this.queryParam,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        console.log(res)
        if (res.data.code == 500) {
          this.$message.error(res.data.msg)
        } else {
          var str = process.env.VUE_APP_API_BASE_URL + '/order/lock/export?pageNum=1&pageSize=10'
          for (let i in this.queryParam) {
            if (this.queryParam[i] != undefined) {
              str = str + '&' + i + '=' + this.queryParam[i]
            }
          }
          str = str + '&token=' + this.headers.token
          window.open(str)
        }
      })
    },
    reformistOk() {
      this.formreformist.validateFields((err, values) => {
        if (!err) {
          // console.log(values)
          getchangeOrderPrincipal(values).then((res) => {
            if (res.code === 0) {
              this.reformistible = false
              this.query()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    orderReformist(record) {
      this.formreformist.resetFields()
      this.reformistible = true
      this.$nextTick(() => {
        this.formreformist.setFieldsValue(pick(record, 'orderId'))
      })
      let orderPrincipal = record.orderPrincipal
      if (orderPrincipal) {
        setTimeout(
          () =>
            this.formreformist.setFieldsValue({
              oldorderPrincipal: orderPrincipal,
            }),
          16
        )
      }
    },
    query() {
      this.isTrue = false
      this.orderTypeId = undefined
      // delete this.queryParam.orderType
      this.queryParam.pageNum = this.current
      this.queryParam.pageSize = this.pageSize
      this.handloadData()

      this.selectedRowKeys = []
      this.selectedRows = []
    },
    removeTypechange(value) {
      // console.log(value)
      if (value != 3) {
        this.removerequiredbool = false
      } else {
        this.removerequiredbool = true
      }
    },
    empty() {
      this.form.setFieldsValue({
        settleStatus: undefined,
        settleCycle: undefined,
      })
      this.List = []
      this.settlement_status = []
      this.settle_cycle = []
      this.queryParam = {}
      this.dtoListtab = {}
      this.dtoListtab2 = {}
      this.dtoListtab3 = {}
      this.checkboxlist = {}
      this.timeType1 = ''
      this.timeType2 = ''
      this.timeType3 = ''
      this.selectedRowKeys = []
      this.selectedRows = []
      this.showReserveFailType = false
    },
    addremark(record) {
      if (record) {
        this.$refs.changeremarksmodel.showChangeRemark(record.orderId)
      }
    },
    determinechangeclientAddress() {
      this.formchangeclientAddress.validateFields((err, values) => {
        values.clientAddress = values.address
        if (!err) {
          getupdateOrder({ orderId: values.orderId, orderClient: values }).then((res) => {
            if (res.code === 0) {
              this.changeclientAddressible = false
              this.$message.success('操作成功')
              this.query()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    changeclientAddress(record) {
      this.changeclientAddressible = true
      this.$nextTick(() => {
        this.formchangeclientAddress.setFieldsValue(
          pick(record, 'orderId', 'provinceId', 'cityId', 'countyId', 'address')
        )
      })
      getselectCityName({ provinceCode: record.provinceId }).then((res) => {
        if (res.code === 0) {
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
      getselectAreaName({ cityCode: record.cityId }).then((res) => {
        if (res.code === 0) {
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    reassignmentorder(record) {
      getagainDispatchOrder({ orderId: record.orderId, procInstId: record.procInstId }).then((res) => {
        if (res.code === 0) {
          this.query()
          this.$message.success('操作成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    dispatchBatch() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.error('至少选择一条数据')
      } else {
        this.$refs.leaflets.showleaflets(this.selectedRowKeys)
      }
    },
    ExamineBatch() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.error('至少选择一条数据')
      } else {
        batchCustomerServiceApply(this.selectedRowKeys).then((res) => {
          if (res.code == 0) {
            this.$message.success('审核成功')
            this.query()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    onChangerangepicker(date, dateString) {
      this.queryParam.timeStart1 = dateString[0]
      this.queryParam.timeEnd1 = dateString[1]
    },
    onChangerangepicker2(date, dateString) {
      this.queryParam.timeStart2 = dateString[0]
      this.queryParam.timeEnd2 = dateString[1]
    },
    onChangerangepicker3(date, dateString) {
      this.queryParam.timeStart3 = dateString[0]
      this.queryParam.timeEnd3 = dateString[1]
    },
    editorder(record) {
      this.$nextTick(() => {
        console.log(record)
        this.$refs.editordermodel22.showeditOrder(record.orderId, '', 1, record.orderSubStatusAll, record.orderStatus)
        // this.$refs.editordermodel22.showeditOrder(record.orderId,'',1,record.orderSubStatusAll,record.orderStatus)
      })
    },
    distribute(record) {
      getorderInfo({ orderId: record.orderId }).then((res) => {
        if (res.code === 0) {
          this.$refs.leaflets.showleaflets(res.data)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    selectoptionChange(e) {
      // this.dtoList
    },
    onChangeTemporarily(e) {
      this.$set(this.checkboxlist, 'temporarily', e.target.checked)
      this.queryParam.isTemporarilySettle = e.target.checked ? '1' : '0'
    },
    onChangeUndoneOrder(e) {
      this.$set(this.checkboxlist, 'undoneOrder', e.target.checked)
      this.queryParam.isUndoneOrder = e.target.checked ? '1' : '0'
    },
    onChangeMyOrder(e) {
      this.$set(this.checkboxlist, 'myOrder', e.target.checked)
      this.queryParam.isMyOrder = e.target.checked ? '1' : '0'
    },
    onChangeUrgentOrder(e) {
      this.$set(this.checkboxlist, 'urgentOrder', e.target.checked)
      this.queryParam.isUrgentOrder = e.target.checked ? '1' : '0'
    },
    onChangeMainOrder(e) {
      this.$set(this.checkboxlist, 'mainOrder', e.target.checked)
      this.queryParam.isMainOrder = e.target.checked ? '1' : '0'
    },
    onChangeFreezeOrder(e) {
      this.$set(this.checkboxlist, 'freezeOrder', e.target.checked)
      this.queryParam.isFreezeOrder = e.target.checked ? '1' : '0'
    },
    goNewlyaddedOrderList() {
      this.$refs.newlyaddedorderlist.showNewlyaddedOrderList()
      // this.$router.push({name:'NewlyaddedOrderList'})
    },
    async installChange(e) {
      this.List = []
      this.queryParam.orderType = undefined
      await getList(e).then((res) => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 单选
    onChangeRadioGroup(e) {
      console.log(e.target.value)
    },
    // 多选
    onChangeCheckbox(checkedValues) {
      console.log(checkedValues)
      console.log(this.valuecheckbox)
    },
    // 市
    getselect(e) {
      this.selectCityName = []
      // this.queryParam.cityId=undefined
      // this.queryParam.countyId=undefined
      this.formchangeclientAddress.setFieldsValue({
        cityId: undefined,
        countyId: undefined,
        address: undefined,
      })
      getselectCityName({ provinceCode: e }).then((res) => {
        if (res.code === 0) {
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName(e) {
      this.selectAreaName = []
      this.formchangeclientAddress.setFieldsValue({
        countyId: undefined,
        address: undefined,
      })
      getselectAreaName({ cityCode: e }).then((res) => {
        if (res.code === 0) {
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getAreaStatu() {
      this.formchangeclientAddress.setFieldsValue({
        address: undefined,
      })
    },
    countyonChange(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.countyId, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.countyId, '')
      }
    },
    // 型号
    changeModelName(e) {
      this.queryParam.modelId = e
    },
    // 品牌
    changeBrandName(e) {
      this.queryParam.brandId = e
    },
    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },
    // 移除
    delByIds(record) {
      this.form.resetFields()
      this.removeible = true
      this.removerequiredbool = false
      this.orderId = record.orderId
    },
    // removerequiredbool
    // 移除确定时调用的方法
    async confirmOk() {
      await this.form.validateFields((err, values) => {
        values.removeText = values.removeText ? values.removeText : '""'
        if (!err) {
          getdeleteOrder({ orderId: this.orderId, removeText: values.removeText, removeType: values.removeType }).then(
            (res) => {
              if (res.code === 0) {
                this.removeible = false
                this.removeLoading = false
                this.query()
              } else {
                this.$message.error(res.msg)
              }
            }
          )
        }
      })
    },
    // 移除取消时调用的方法
    confirmCancel() {
      this.removeible = false
      this.orderid = []
    },
    handleremark(record) {
      this.$refs.modal.remark(record)
      console.log(record)
    },
    handleOk() {
      this.query()
      //console.log('handleSaveOk')
    },

    // 更多、隐藏
    getMore() {
      this.Ifstatus = 1
    },
    hiddenMore() {
      this.Ifstatus = 0
    },
    // 更多、隐藏
    getMoreRight() {
      this.Ifstatusicon = 1
    },
    hiddenMoreLeft() {
      this.Ifstatusicon = 0
    },
    SetOptionTitle() {
      var selects = document.getElementsByTagName('select')
      console.log('selects', selects)
      if (selects.length > 0) {
        for (var i = 0; i < selects.length; i++) {
          var options = selects[i].options
          if (selects[i].options.length > 0) {
            for (var j = 0; j < options.length; j++) {
              if (options[j].title == '') options[j].title = options[j].text
            }
          }
        }
      }
    },
  },
  watch: {
    $route(to, from) {
      // console.log('dingdan',from)
      this.loading = true
      this.orderTypeId = this.$route.params.id
      this.orderjumpStatus = this.$route.params.status
      if (this.$route.params.jumpList && to.path == '/order/orderList') {
        this.queryParam = {}
        this.checkboxlist = {
          temporarily: false,
          freezeOrder: false,
          undoneOrder: false,
          urgentOrder: false,
          myOrder: false,
        }
        this.jumpList = this.$route.params.jumpList
        this.queryParam.orderStatus = this.jumpList.orderStatus
        this.queryParam.isFreezeOrder = this.jumpList.isFreezeOrder
        this.queryParam.isTemporarilySettle = this.jumpList.isTemporarilySettle
        this.queryParam.timeOutType = this.jumpList.timeOutType
        this.queryParam.isUrgentOrder = this.jumpList.isUrgentOrder
        this.queryParam.isMyOrder = this.jumpList.isMyOrder
        this.checkboxlist.freezeOrder = this.jumpList.isFreezeOrder == 1 ? true : false
        this.checkboxlist.temporarily = this.jumpList.isTemporarilySettle == 1 ? true : false
        this.checkboxlist.undoneOrder = this.jumpList.timeOutType == 1 ? true : false
        this.checkboxlist.urgentOrder = this.jumpList.isUrgentOrder == 1 ? true : false
        this.checkboxlist.myOrder = this.jumpList.isMyOrder == 1 ? true : false
        this.queryParam.timeType1 = this.jumpList.timeType1
        if (this.jumpList.timeStart1 != null && this.jumpList.timeEnd1 != null) {
          this.timeType1 = [moment(this.jumpList.timeStart1), moment(this.jumpList.timeEnd1)]
          this.queryParam.timeStart1 = this.jumpList.timeStart1
          this.queryParam.timeEnd1 = this.jumpList.timeEnd1
        } else {
          this.timeType1 = null
          this.queryParam.timeStart1 = null
          this.queryParam.timeEnd1 = null
        }
      }
      if (from.path != '/order/orderList') {
        this.$nextTick(() => {
          this.getdataList1(1)
        })
      }
    },
  },
}
</script>

<style scoped>
/deep/ .clickRowStyle {
  background: #ffbcb7;
}
/*/deep/ .clickRowStyle2 {*/
/*background: #a4ffa1;*/
/*}*/
/deep/ .clickRowStyle3 {
  background: #f9ff9f;
}
/deep/ .clickRowStyle4 {
  background: #ffa07a;
}
/deep/ .ant-calendar-picker {
  width: 276px;
}
/deep/ .notshow {
  display: none;
}
/deep/ .ant-table th {
  white-space: nowrap;
}

/*</a-form-item>*/
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
/deep/ p {
  margin-top: 0;
  margin-bottom: 0em;
}
/deep/ .ant-pagination-options-quick-jumper input {
  width: 80px;
}
</style>